import { TranslateResult } from 'vue-i18n';

export class ChipModel {
    public id: any;
    public name: string | TranslateResult;
    public checked: boolean;

    constructor(id: any, name: string | TranslateResult) {
        this.id = id;
        this.name = name;
        this.checked = false;
    }
}

export class PoiFilterSet {
    public topicFilters: number[];
    public unlockFilters: number[];
    public experienceFilters: number[];
    public communityFilters: string[];
    public favoriteFilters: number[];
}

export class RouteFilterSet {
    public profileFilters: number[];
}
